import { put, takeLatest, select, call } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { setPulsaraDateRangeOptions } from '../store/options.actions'
import { getServiceIdSelector } from '../../user/selectors'
import { OptionsService } from '../services/options.service'
import { IOptionsResponse } from '../../../common/common.types'

export function* getPulsaraDateRangeOptionsSaga() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getPulsaraDateRangeOptions])
    const { entity } = response
    if (entity) yield put(setPulsaraDateRangeOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getPulsaraDateRangeOptionsSaga() error: ${e}`))
  }
}

export function* getPulsaraDateRangeOptionsSagaWatcher() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getPulsaraDateRangeOptionsSaga)
}
